import React, { useState, useEffect } from 'react';

const VerificationPage = () => {
  const [timer, setTimer] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [step, setStep] = useState(0);

  const startTimer = (seconds, callback) => {
    setTimer(seconds);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          callback();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setStep(3);
    setShowButton(true);
  }, []);

  const handleFirstButton = () => {
    setStep(4);
    setShowButton(false);
    startTimer(10, () => {
      setShowButton(true);
    });
  };

  const handleSecondButton = () => {
    setStep(5);
    setShowButton(false);
    
    const bottomSection = document.getElementById('bottom-verification');
    if (bottomSection) {
      bottomSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setTimeout(() => {
      setShowButton(true);
    }, 1500);
  };

  const handleFinalButton = () => {
    setStep(6);
    setShowButton(false);
    startTimer(10, () => {
      setShowButton(true);
    });
  };

  const handleRedirect = () => {
    window.location.href = 'https://www.qorno.com/search/a/viral%20girl';
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-purple-600 text-white py-6 shadow-md">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold">Verification Process</h1>
          {/* <p className="text-purple-100">Complete our security process</p> */}
        </div>
      </header>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">

        {/* STEP 3 - Top Section */}
        <section className="mb-6 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg p-4 text-white shadow-md">
  <div className="max-w-md mx-auto text-center">
    <h2 className="text-xl font-semibold mb-2">🔐 Security Verification</h2>
    <p className="mb-3 text-sm text-purple-100">
      This verification is necessary to ensure your link security
    </p>

    {step >= 3 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3 mb-3">
        <div className="inline-block bg-green-400 text-gray-900 px-3 py-1 rounded-full mb-2 text-sm font-medium">
          ✓ Step 3/4 Complete
        </div>
      </div>
    )}

    {step === 3 && showButton && (
      <button
        onClick={handleFirstButton}
        className="bg-white text-purple-600 font-semibold py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 shadow"
      >
        🚀 Start
      </button>
    )}

    {step === 4 && timer !== null && timer > 0 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3">
        <div className="text-3xl font-bold mb-1">{timer}</div>
        <p className="text-purple-100 text-sm">Link is uploading...</p>
      </div>
    )}

    {step === 4 && showButton && (
      <button
        onClick={handleSecondButton}
        className="bg-yellow-400 text-gray-900 font-semibold py-2 px-4 rounded-md hover:bg-yellow-300 transition duration-300 shadow"
      >
        ⬇️ Continue
      </button>
    )}
  </div>
</section>


        {/* Investment Guides */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">📖 Investment Guides</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">🏦 Fixed Deposits</h3>
              <p className="text-gray-600 mb-4">
                FD is the safest investment option. Bank fixed deposits provide guaranteed returns. 
                Senior citizens get higher interest rates.
              </p>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>✓ Risk-free investment</li>
                <li>✓ Guaranteed returns</li>
                <li>✓ Tax-saving FD available</li>
                <li>✓ Tenure: 7 days to 10 years</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">📈 Equity Mutual Funds</h3>
              <p className="text-gray-600 mb-4">
                Equity funds invest in the stock market and provide good returns in the long-term. 
                You can start with small amounts through SIP.
              </p>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>✓ High growth potential</li>
                <li>✓ SIP option available</li>
                <li>✓ Professional management</li>
                <li>✓ Tax benefits under ELSS</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">🏠 Real Estate</h3>
              <p className="text-gray-600 mb-4">
                Real estate is a traditional and stable investment. Property value increases over time 
                and rental income can also be earned.
              </p>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>✓ Long-term appreciation</li>
                <li>✓ Rental income</li>
                <li>✓ Tangible asset</li>
                <li>✓ Hedge against inflation</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">💰 Gold Investment</h3>
              <p className="text-gray-600 mb-4">
                Gold is a safe haven asset. Digital gold, sovereign gold bonds, and gold ETF 
                are modern options for investing in gold.
              </p>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>✓ Portfolio diversification</li>
                <li>✓ Inflation hedge</li>
                <li>✓ High liquidity</li>
                <li>✓ No storage hassle (digital)</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Market News */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">📰 Latest Market Updates</h2>
          
          <div className="space-y-4">
            <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-800">RBI Monetary Policy Update</h3>
                <span className="text-xs text-gray-500">2 hours ago</span>
              </div>
              <p className="text-gray-600 text-sm">
                RBI has kept the repo rate unchanged at 6.5%. Inflation control is still a priority.
              </p>
            </div>

            <div className="bg-green-50 border-l-4 border-green-500 p-5 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-800">IT Sector Shows Growth</h3>
                <span className="text-xs text-gray-500">5 hours ago</span>
              </div>
              <p className="text-gray-600 text-sm">
                TCS and Infosys have announced strong quarterly results. IT stocks are bullish.
              </p>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-5 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-gray-800">Global Market Impact</h3>
                <span className="text-xs text-gray-500">1 day ago</span>
              </div>
              <p className="text-gray-600 text-sm">
                US Federal Reserve policy decision may have a positive impact on Indian markets.
              </p>
            </div>
          </div>
        </section>

        {/* Trading Tips */}
        <section className="mb-12 bg-gray-50 rounded-xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">💡 Smart Trading Tips</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6 shadow">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">✅ Do's</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Research before investing</li>
                <li>• Set stop-loss</li>
                <li>• Diversify your portfolio</li>
                <li>• Maintain long-term perspective</li>
                <li>• Regular monitoring</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg p-6 shadow">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">❌ Don'ts</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Don't rely on tips</li>
                <li>• Avoid over-trading</li>
                <li>• Don't invest with loans</li>
                <li>• Don't panic sell</li>
                <li>• Don't put all money in one place</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Budget Planning */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">💵 Monthly Budget Planning</h2>
          
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md">
            <div className="grid md:grid-cols-4 gap-4">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl mb-2">50%</div>
                <div className="font-semibold text-gray-800">Needs</div>
                <div className="text-sm text-gray-600">Essential expenses</div>
              </div>

              <div className="text-center p-4 bg-green-50 rounded-lg">
                <div className="text-3xl mb-2">30%</div>
                <div className="font-semibold text-gray-800">Wants</div>
                <div className="text-sm text-gray-600">Lifestyle expenses</div>
              </div>

              <div className="text-center p-4 bg-purple-50 rounded-lg">
                <div className="text-3xl mb-2">20%</div>
                <div className="font-semibold text-gray-800">Savings</div>
                <div className="text-sm text-gray-600">Savings and investment</div>
              </div>

              <div className="text-center p-4 bg-orange-50 rounded-lg">
                <div className="text-3xl mb-2">👍</div>
                <div className="font-semibold text-gray-800">50-30-20 Rule</div>
                <div className="text-sm text-gray-600">Ideal budget</div>
              </div>
            </div>
          </div>
        </section>

        {/* STEP 4 - Bottom Section */}
        <section id="bottom-verification" className="mb-6 bg-gradient-to-r from-green-500 to-blue-600 rounded-lg p-4 text-white shadow-md">
  <div className="max-w-md mx-auto text-center">
    <h2 className="text-xl font-semibold mb-2">🎊 Final Verification</h2>
    <p className="mb-3 text-sm text-green-100">
      Just a few moments left! Your exclusive link is getting ready
    </p>

    {step >= 5 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3 mb-3">
        <div className="inline-block bg-yellow-400 text-gray-900 px-3 py-1 rounded-full mb-2 text-sm font-medium">
          ✓ Step 4/4 Complete
        </div>
      </div>
    )}

    {step === 5 && !showButton && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3">
        <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full mx-auto mb-2"></div>
        <p className="text-green-100 text-sm">Preparing...</p>
      </div>
    )}

    {step === 5 && showButton && (
      <button
        onClick={handleFinalButton}
        className="bg-white text-green-600 font-semibold py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 shadow"
      >
        ✨ Complete
      </button>
    )}

    {step === 6 && timer !== null && timer > 0 && (
      <div className="bg-white/20 backdrop-blur-sm rounded-md p-3">
        <div className="text-3xl font-bold mb-1">{timer}</div>
        <p className="text-green-100 text-sm">Please wait...</p>
      </div>
    )}

    {step === 6 && showButton && (
      <button
        onClick={handleRedirect}
        className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-semibold py-2 px-4 rounded-md hover:from-yellow-500 hover:to-orange-600 transition duration-300 shadow"
      >
        🎉 Get Link
      </button>
    )}
  </div>
</section>


        {/* Final Tips */}
        <section className="mb-12">
          <div className="bg-gradient-to-r from-yellow-100 to-orange-100 border border-yellow-300 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">⚡ Pro Tips</h3>
            <ul className="space-y-2 text-gray-700">
              <li>• Regular saving is the first step to wealth creation</li>
              <li>• Always keep an emergency fund of 6-12 months of expenses</li>
              <li>• Insurance coverage should be adequate</li>
              <li>• Start retirement planning early - benefit from compounding</li>
              <li>• Write down and track your financial goals</li>
            </ul>
          </div>
        </section>

      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="container mx-auto px-4 text-center">
          <p className="mb-2">© 2026 Financial Hub - Verification Portal</p>
          <p className="text-gray-400 text-sm">
            Your information is completely secure and confidential.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default VerificationPage;